/** Persist list query so info "List" returns with filters. */
export const DEVICE_PRODUCTION_LIST_SEARCH_KEY =
  "device-production-list-search";

export const getDeviceProductionListPath = () => {
  const q = sessionStorage.getItem(DEVICE_PRODUCTION_LIST_SEARCH_KEY) || "";
  return `/device-production${q}`;
};

export const getDeviceProductionRowId = (record) =>
  record?.ProductionNo ?? record?.production_no ?? record?.id;
